import { Alert, Box } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { ServiceCode } from '../../../../../common/enums/serviceCode';
import { fetchJson } from '../../../../store/fetch';
import { useEpisodeContext } from '../../../../utils/hooks/useEpisodeContext';

interface IOrthOAlertProps {
    buttonText: string;
    serviceCodeForButton: ServiceCode.OrthO | ServiceCode.OrthOFol;
    text: string;
}

export function OrthOAlert(props: IOrthOAlertProps) {
    const { changeServiceIdForAddingProcess } = useEpisodeContext();
    const [orthOServiceIdForButton, setOrthOServiceIdForButton] = useState<string | null>(null);
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        loadOrthOServiceForButton();
    }, []);

    useEffect(() => {
        if (orthOServiceIdForButton) {
            setShowButton(true);
        }
    }, [orthOServiceIdForButton]);

    return (
        <Alert appearance="info">
            <Box
                alignItems="center"
                display="flex"
                flexWrap={['wrap', null, null, 'nowrap']}
                gap={2}
                justifyContent="space-between"
            >
                {props.text}

                {showButton && orthOServiceIdForButton && (
                    <Alert.Button onClick={() => changeServiceIdForAddingProcess(orthOServiceIdForButton)}>
                        {props.buttonText}
                    </Alert.Button>
                )}
            </Box>
        </Alert>
    );

    async function loadOrthOServiceForButton() {
        const result = await fetchJson(`/api/services?code=${props.serviceCodeForButton}&serviceIsActive=true`, 'GET');

        if (result.json.items?.length === 1) {
            setOrthOServiceIdForButton(result.json.items[0].id);
        } else {
            throw new Error(`Cannot find ${props.serviceCodeForButton} service`);
        }
    }
}
